import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="options" {...props} />;
}

export const meta = {
  id: 'CMSSettingsDetails',
  title: 'CMSSettingsDetails',
  category: 'CMS',
  unique: false,
  icon: TheIcon,
  version: '1.0.0',
  description: `The settings to be used related to the CMS for the tenant`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 670,
    height: 510
  }
};
